import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		user: JSON.parse(sessionStorage.getItem('currentUser')) || null,
		coins: 1000,
		isLoggedIn: false,
		toast: {
			show: false,
			message: ''
		}
	},

	mutations: {
		SET_USER(state, user) {
			state.user = user
			state.isLoggedIn = !!user
		},
		updateTokenBalance(state, tokenBalance) {
			state.tokenBalance = tokenBalance;
		},

		SET_COINS(state, coins) {
			state.coins = coins
		},

		CONSUME_COINS(state, amount) {
			state.coins -= amount
		},

		SHOW_TOAST(state, message) {
			state.toast.show = true
			state.toast.message = message
		},

		HIDE_TOAST(state) {
			state.toast.show = false
			state.toast.message = ''
		}
	},

	actions: {
		login({
			commit
		}, userData) {
			commit('SET_USER', userData)
			localStorage.setItem('currentUser', JSON.stringify(userData))

			// 恢复用户的FF币
			const savedCoins = localStorage.getItem(`user_coins_${userData.id}`)
			if (savedCoins) {
				commit('SET_COINS', parseInt(savedCoins))
			}
		},

		logout({
			commit
		}) {
			commit('SET_USER', null)
			localStorage.removeItem('currentUser')
		},

		consumeCoins({
			commit,
			state
		}, amount) {
			if (state.coins >= amount) {
				commit('CONSUME_COINS', amount)
				if (state.user) {
					localStorage.setItem(`user_coins_${state.user.id}`, state.coins)
				}
				return true
			}
			return false
		},

		showToast({
			commit
		}, message) {
			commit('SHOW_TOAST', message)
			setTimeout(() => {
				commit('HIDE_TOAST')
			}, 3000)
		}
	},

	getters: {
		isLoggedIn: state => state.isLoggedIn,
		currentUser: state => state.user,
		userCoins: state => state.coins
	}
})